import { render, staticRenderFns } from "./MessengerMessageProfile.vue?vue&type=template&id=1a8e6463&scoped=true"
import script from "./MessengerMessageProfile.vue?vue&type=script&lang=js"
export * from "./MessengerMessageProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8e6463",
  null
  
)

export default component.exports